(function () {
  if (customElements.get('easy-quote-order')) return;

  class EasyQuoteOrder extends HTMLElement {
    connectedCallback() {
      this.config = this.readJson('[data-eqo-config]') || {};
      this.catalog = this.readJson('[data-eqo-catalog]') || [];
      this.blockList = this.querySelector('[data-eqo-block-list]');
      this.blockTemplate = this.querySelector('[data-eqo-block-template]');
      this.blocks = [];
      this.blockIdCounter = 0;
      this.categoryOptions = (this.config.presets || [])
        .map(function (p) {
          return (p || '').trim();
        })
        .filter(Boolean);
      this.resolveDesignImages();

      this.bindGlobalEvents();
      this.initBlocks();
      this.recalculate();
    }

    resolveDesignImages() {
      var catalog = this.catalog || [];
      (this.config.designs || []).forEach(function (design) {
        if (design.image) return;
        var match = catalog.find(function (product) {
          return (product.tags || []).indexOf(design.tag) !== -1 && product.image;
        });
        if (match) design.image = match.image;
      });
    }

    readJson(selector) {
      var el = this.querySelector(selector);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.error('easy-quote-order: JSON parse error', e);
        return null;
      }
    }

    setTextAll(selector, value) {
      this.querySelectorAll(selector).forEach(function (el) {
        el.textContent = value;
      });
    }

    eachEl(selector, fn) {
      this.querySelectorAll(selector).forEach(fn);
    }

    bindGlobalEvents() {
      var self = this;
      this.querySelectorAll('[data-eqo-add-block]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.hasAttribute('data-eqo-add-to-end')) {
            self.addBlock('', { scrollTo: true });
            return;
          }
          // スマホでは追加ボタンが下にあるため、新規ブロックを先頭に差し込む
          var prepend = window.matchMedia('(max-width: 750px)').matches;
          self.addBlock('', { prepend: prepend });
        });
      });
      this.querySelectorAll('[data-eqo-cart-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.addToCart();
        });
      });
    }

    initBlocks() {
      var options = this.categoryOptions;
      if (!options.length) {
        this.categoryOptions = ['同僚・友人', '上司・先輩', '親族', 'その他'];
        options = this.categoryOptions;
      }
      var initialCount = Math.min(this.config.initialBlockCount || 3, options.length);
      for (var i = 0; i < initialCount; i++) {
        this.addBlock(options[i], { preset: [
          { quantity: 20, course: 'course_4800' },
          { quantity: 5, course: 'course_7800' },
          { quantity: 10, course: 'course_10800' }
        ][i] });
      }
      if (!initialCount) this.addBlock(options[0] || '同僚・友人');
    }

    addBlock(label, options) {
      if (!this.blockTemplate || !this.blockList) return;
      options = options || {};

      var node = this.blockTemplate.content.cloneNode(true);
      var el = node.querySelector('[data-eqo-block]');
      var id = 'eqo-block-' + ++this.blockIdCounter;
      el.dataset.blockId = id;

      var defaultLabel = label || this.categoryOptions[0] || '同僚・友人';
      var defaults = this.config.defaultSelection || {};
      var firstDesign = this.config.designs && this.config.designs[0] ? this.config.designs[0].tag : '';
      var firstSet = this.config.sets && this.config.sets[0] ? this.config.sets[0].tag : '';
      var firstCourse = this.config.courses && this.config.courses[0] ? this.config.courses[0].tag : '';
      var block = {
        id: id,
        el: el,
        label: defaultLabel,
        quantity: options.preset ? options.preset.quantity : 10,
        series: defaults.design || firstDesign,
        set: defaults.set || firstSet,
        course: (options.preset && options.preset.course) || defaults.course || firstCourse,
      };

      this.populateBlock(block);
      this.bindBlockEvents(block);

      if (options.prepend && this.blockList.firstElementChild) {
        this.blocks.unshift(block);
        this.blockList.insertBefore(el, this.blockList.firstElementChild);
      } else {
        var addCard = this.blockList.querySelector('[data-eqo-add-card]');
        this.blocks.push(block);
        if (addCard) {
          this.blockList.insertBefore(el, addCard);
        } else {
          this.blockList.appendChild(el);
        }
      }

      this.updateRemoveButtons();
      this.recalculate();

      if (options.scrollTo) {
        el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } else if (options.prepend) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    removeBlock(block) {
      if (this.blocks.length <= 1) return;
      var idx = this.blocks.indexOf(block);
      if (idx === -1) return;
      block.el.remove();
      this.blocks.splice(idx, 1);
      this.updateRemoveButtons();
      this.recalculate();
    }

    populateBlock(block) {
      var el = block.el;
      this.renderCategoryInput(el.querySelector('[data-eqo-label]'), block.label);
      el.querySelector('[data-eqo-qty]').value = block.quantity;

      this.renderDesignButtons(block);
      this.renderSelect(el.querySelector('[data-eqo-set]'), this.config.sets, block.set);
      this.renderSelect(el.querySelector('[data-eqo-course]'), this.config.courses, block.course);
      this.resolveSelection(block);
      this.applyAvailability(block);
    }

    renderCategoryInput(input, value) {
      if (!input) return;
      input.value = value || '';
    }

    updateRemoveButtons() {
      var showRemove = this.blocks.length > 1;
      this.blocks.forEach(function (block) {
        block.el.querySelector('[data-eqo-remove]').style.display = showRemove ? '' : 'none';
      });
    }

    renderDesignButtons(block) {
      var list = block.el.querySelector('[data-eqo-design-list]');
      list.innerHTML = '';
      var self = this;
      (this.config.designs || []).forEach(function (design) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'eqo__design-btn' + (design.tag === block.series ? ' is-selected' : '');
        btn.dataset.series = design.tag;
        btn.setAttribute('aria-label', design.label);
        btn.setAttribute('aria-pressed', design.tag === block.series ? 'true' : 'false');

        if (design.image) {
          var img = document.createElement('img');
          img.src = design.image;
          img.alt = design.label;
          img.width = 160;
          img.height = 160;
          btn.appendChild(img);
        } else {
          btn.textContent = design.label.slice(0, 1);
        }

        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          block.series = design.tag;
          self.resolveSelection(block);
          self.applyAvailability(block);
          self.recalculate();
        });

        li.appendChild(btn);
        list.appendChild(li);
      });

      var selected = (this.config.designs || []).find(function (d) {
        return d.tag === block.series;
      });
      block.el.querySelector('[data-eqo-design-name]').textContent = selected ? selected.label : '';
    }

    renderSelect(select, options, value) {
      if (!select) return;
      select.innerHTML = '';
      (options || []).forEach(function (opt) {
        var option = document.createElement('option');
        option.value = opt.tag;
        option.textContent = opt.label;
        if (opt.tag === value) option.selected = true;
        select.appendChild(option);
      });
    }

    getFieldMap() {
      return {
        design: { key: 'series', options: this.config.designs || [] },
        set: { key: 'set', options: this.config.sets || [] },
        course: { key: 'course', options: this.config.courses || [] },
      };
    }

    getFilterPriority() {
      var order = ['design', 'set', 'course'];
      var priority = (this.config.filterPriority || [])
        .map(function (field) {
          return String(field || '').trim();
        })
        .filter(function (field) {
          return order.indexOf(field) !== -1;
        });
      order.forEach(function (field) {
        if (priority.indexOf(field) === -1) priority.push(field);
      });
      return priority;
    }

    getBlockValue(block, field) {
      var map = this.getFieldMap()[field];
      return map ? block[map.key] : '';
    }

    setBlockValue(block, field, value) {
      var map = this.getFieldMap()[field];
      if (map) block[map.key] = value;
    }

    getAvailableTags(block, field) {
      var self = this;
      var map = this.getFieldMap()[field];
      var available = {};
      if (!map) return available;

      var priority = this.getFilterPriority();
      var fieldIndex = priority.indexOf(field);
      var products = (this.catalog || []).filter(function (product) {
        var tags = product.tags || [];
        for (var i = 0; i < fieldIndex; i++) {
          var upperTag = self.getBlockValue(block, priority[i]);
          if (upperTag && tags.indexOf(upperTag) === -1) return false;
        }
        return true;
      });

      var optionTags = (map.options || []).map(function (opt) {
        return opt.tag;
      });
      products.forEach(function (product) {
        var tags = product.tags || [];
        optionTags.forEach(function (tag) {
          if (tag && tags.indexOf(tag) !== -1) available[tag] = true;
        });
      });
      return available;
    }

    resolveSelection(block) {
      var self = this;
      var defaults = this.config.defaultSelection || {};
      this.getFilterPriority().forEach(function (field) {
        var available = self.getAvailableTags(block, field);
        var current = self.getBlockValue(block, field);
        if (current && available[current]) return;

        var defaultTag = defaults[field];
        if (defaultTag && available[defaultTag]) {
          self.setBlockValue(block, field, defaultTag);
          return;
        }

        var map = self.getFieldMap()[field];
        var firstValid = (map.options || []).find(function (opt) {
          return available[opt.tag];
        });
        self.setBlockValue(block, field, firstValid ? firstValid.tag : '');
      });
    }

    applyAvailability(block) {
      var self = this;
      var availableDesigns = this.getAvailableTags(block, 'design');
      var list = block.el.querySelector('[data-eqo-design-list]');
      if (list) {
        list.querySelectorAll('.eqo__design-btn').forEach(function (btn) {
          var tag = btn.dataset.series;
          var isAvailable = !!availableDesigns[tag];
          var isSelected = tag === block.series;
          btn.disabled = !isAvailable;
          btn.classList.toggle('is-unavailable', !isAvailable);
          btn.classList.toggle('is-selected', isSelected && isAvailable);
          btn.setAttribute('aria-pressed', isSelected && isAvailable ? 'true' : 'false');
        });
      }

      var selected = (this.config.designs || []).find(function (design) {
        return design.tag === block.series;
      });
      var nameEl = block.el.querySelector('[data-eqo-design-name]');
      if (nameEl) nameEl.textContent = selected ? selected.label : '';

      ['set', 'course'].forEach(function (field) {
        var select = block.el.querySelector(field === 'set' ? '[data-eqo-set]' : '[data-eqo-course]');
        if (!select) return;
        var available = self.getAvailableTags(block, field);
        var current = self.getBlockValue(block, field);
        Array.prototype.forEach.call(select.options, function (option) {
          option.disabled = !available[option.value];
          option.selected = option.value === current;
        });
        if (current) select.value = current;
      });
    }

    bindBlockEvents(block) {
      var self = this;
      var el = block.el;

      el.querySelector('[data-eqo-remove]').addEventListener('click', function () {
        self.removeBlock(block);
      });

      el.querySelector('[data-eqo-label]').addEventListener('input', function (e) {
        block.label = e.target.value;
      });

      el.querySelector('[data-eqo-qty-minus]').addEventListener('click', function () {
        block.quantity = Math.max(1, block.quantity - 1);
        el.querySelector('[data-eqo-qty]').value = block.quantity;
        self.recalculate();
      });

      el.querySelector('[data-eqo-qty-plus]').addEventListener('click', function () {
        block.quantity += 1;
        el.querySelector('[data-eqo-qty]').value = block.quantity;
        self.recalculate();
      });

      el.querySelector('[data-eqo-qty]').addEventListener('change', function (e) {
        var val = parseInt(e.target.value, 10);
        block.quantity = isNaN(val) || val < 1 ? 1 : val;
        e.target.value = block.quantity;
        self.recalculate();
      });

      el.querySelector('[data-eqo-set]').addEventListener('change', function (e) {
        block.set = e.target.value;
        self.resolveSelection(block);
        self.applyAvailability(block);
        self.recalculate();
      });

      el.querySelector('[data-eqo-course]').addEventListener('change', function (e) {
        block.course = e.target.value;
        self.resolveSelection(block);
        self.applyAvailability(block);
        self.recalculate();
      });
    }

    findProduct(series, setTag, course) {
      return this.catalog.find(function (product) {
        var tags = product.tags || [];
        return tags.indexOf(series) !== -1 && tags.indexOf(setTag) !== -1 && tags.indexOf(course) !== -1;
      });
    }

    getUnitPrice(product, quantity) {
      var price = product.price;
      var breaks = product.quantityPriceBreaks || [];
      if (breaks.length) {
        var sorted = breaks.slice().sort(function (a, b) {
          return b.minimumQuantity - a.minimumQuantity;
        });
        for (var i = 0; i < sorted.length; i++) {
          if (quantity >= sorted[i].minimumQuantity) {
            price = sorted[i].price;
            break;
          }
        }
      }
      return price;
    }

    getCompareUnit(product) {
      if (product.compareAt && product.compareAt > product.price) {
        return product.compareAt;
      }
      return product.price;
    }

    calculateBlock(block) {
      var product = this.findProduct(block.series, block.set, block.course);
      var errorEl = block.el.querySelector('[data-eqo-block-error]');

      if (!product) {
        errorEl.textContent = '該当する商品が見つかりません。選択内容をご確認ください。';
        errorEl.classList.remove('hidden');
        return {
          valid: false,
          product: null,
          subtotal: 0,
          compareTotal: 0,
          saving: 0,
          quantity: block.quantity,
        };
      }

      if (!product.available) {
        errorEl.textContent = '選択した商品は現在ご購入いただけません。';
        errorEl.classList.remove('hidden');
        return {
          valid: false,
          product: product,
          subtotal: 0,
          compareTotal: 0,
          saving: 0,
          quantity: block.quantity,
        };
      }

      errorEl.classList.add('hidden');
      var unitPrice = this.getUnitPrice(product, block.quantity);
      var compareUnit = this.getCompareUnit(product);
      var subtotal = unitPrice * block.quantity;
      var compareTotal = compareUnit * block.quantity;
      var saving = Math.max(0, compareTotal - subtotal);

      block.el.querySelector('[data-eqo-block-subtotal]').textContent = this.formatMoney(subtotal);
      block.el.querySelector('[data-eqo-block-compare]').textContent = this.formatMoney(compareTotal);
      block.el.querySelector('[data-eqo-block-saving]').textContent = this.formatMoney(saving) + ' お得';

      return {
        valid: true,
        product: product,
        subtotal: subtotal,
        compareTotal: compareTotal,
        saving: saving,
        quantity: block.quantity,
        label: block.label,
      };
    }

    recalculate() {
      var totalGuests = 0;
      var saleTotal = 0;
      var listTotal = 0;
      var allValid = true;
      var results = [];

      this.blocks.forEach(function (block) {
        var result = this.calculateBlock(block);
        results.push(result);
        if (!result.valid) {
          allValid = false;
          return;
        }
        totalGuests += result.quantity;
        saleTotal += result.subtotal;
        listTotal += result.compareTotal;
      }, this);

      var tiers = (this.config.discountTiers || []).slice().sort(function (a, b) {
        return (b.threshold || 0) - (a.threshold || 0);
      });
      var benefitAmount = 0;
      for (var t = 0; t < tiers.length; t++) {
        var thresholdCents = (tiers[t].threshold || 0) * 100;
        if (saleTotal >= thresholdCents && tiers[t].amount) {
          benefitAmount = tiers[t].amount * 100;
          break;
        }
      }

      var grandTotal = Math.max(0, saleTotal - benefitAmount);
      var totalSaving = Math.max(0, listTotal - grandTotal);
      var venueMultiplier = this.config.venueMultiplier || 1.4;
      var venuePrice = Math.round(listTotal * venueMultiplier);
      var compareSaving = Math.max(0, venuePrice - grandTotal);

      this.querySelector('[data-eqo-total-guests]').textContent = totalGuests + '個';
      this.setTextAll('[data-eqo-list-total]', this.formatMoney(listTotal));

      var benefitRow = this.querySelector('[data-eqo-benefit-row]');
      var benefitEl = this.querySelector('[data-eqo-benefit]');
      if (benefitAmount > 0) {
        benefitEl.textContent = '-' + this.formatMoney(benefitAmount);
        benefitRow.classList.remove('hidden');
      } else {
        benefitEl.textContent = '-¥0';
        benefitRow.classList.add('hidden');
      }

      this.setTextAll('[data-eqo-grand-total]', this.formatMoney(grandTotal));
      this.querySelector('[data-eqo-discount-bar]').textContent =
        '合計割引額 ' + this.formatMoney(totalSaving) + ' OFF';
      this.querySelector('[data-eqo-venue-price]').textContent = this.formatMoney(venuePrice);
      this.querySelector('[data-eqo-fitau-price]').textContent = this.formatMoney(grandTotal);
      this.querySelector('[data-eqo-compare-saving]').textContent =
        '式場と比べて ' + this.formatMoney(compareSaving) + ' お得';

      this.updatePromo(saleTotal, benefitAmount);

      var cartDisabled = !allValid || totalGuests === 0;
      this.eachEl('[data-eqo-cart-btn]', function (cartBtn) {
        cartBtn.disabled = cartDisabled;
      });

      this._lastResults = results;
    }

    formatDiscountNumber(yen) {
      return Math.round(yen).toLocaleString('ja-JP');
    }

    fillPromoTemplate(template, values) {
      var text = template || '';
      Object.keys(values).forEach(function (key) {
        text = text.split('{' + key + '}').join(values[key]);
      });
      return text;
    }

    updatePromo(saleTotal, benefitAmount) {
      var promo = this.querySelector('[data-eqo-promo]');
      var body = this.querySelector('[data-eqo-promo-body]');
      if (!promo || !body) return;

      if (!this.config.enableDynamicPromo) {
        if (this.config.promoText) {
          body.textContent = this.config.promoText;
          promo.classList.remove('hidden');
        } else {
          promo.classList.add('hidden');
        }
        return;
      }

      var ascTiers = (this.config.discountTiers || [])
        .slice()
        .filter(function (tier) {
          return tier.threshold && tier.amount;
        })
        .sort(function (a, b) {
          return a.threshold - b.threshold;
        });
      var nextTier = ascTiers.find(function (tier) {
        return tier.threshold * 100 > saleTotal;
      });

      body.textContent = '';

      if (benefitAmount > 0) {
        var currentSpan = document.createElement('span');
        currentSpan.className = 'eqo__promo-current';
        currentSpan.textContent = this.fillPromoTemplate(this.config.promoCurrentTemplate, {
          discount: this.formatDiscountNumber(benefitAmount / 100),
        });
        body.appendChild(currentSpan);
      }

      if (nextTier) {
        if (body.childNodes.length) {
          body.appendChild(document.createTextNode(' '));
        }
        var nextSpan = document.createElement('span');
        nextSpan.className = 'eqo__promo-next';
        nextSpan.textContent = this.fillPromoTemplate(this.config.promoNextTemplate, {
          amount: this.formatMoney(nextTier.threshold * 100 - saleTotal),
          discount: this.formatDiscountNumber(nextTier.amount),
        });
        body.appendChild(nextSpan);
      } else if (benefitAmount > 0) {
        if (body.childNodes.length) {
          body.appendChild(document.createTextNode(' '));
        }
        var maxSpan = document.createElement('span');
        maxSpan.className = 'eqo__promo-max';
        maxSpan.textContent = this.config.promoMaxText || '最大割引が適用されています！';
        body.appendChild(maxSpan);
      } else if (this.config.promoText) {
        body.textContent = this.config.promoText;
      }

      if (body.textContent) {
        promo.classList.remove('hidden');
      } else {
        promo.classList.add('hidden');
      }
    }

    formatMoney(cents) {
      if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, this.config.moneyFormat || window.Shopify.money_format);
      }
      return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
    }

    addToCart() {
      var self = this;
      var cartBtn = this.querySelector('[data-eqo-cart-btn]');

      if (!cartBtn || cartBtn.disabled) return;

      var items = [];
      this._lastResults.forEach(function (result, index) {
        if (!result.valid || !result.product) return;
        var block = self.blocks[index];
        items.push({
          id: parseInt(result.product.variantId, 10),
          quantity: result.quantity,
          properties: {
            ゲスト区分: block.label || 'ゲスト区分' + (index + 1),
          },
        });
      });

      if (!items.length) return;

      this.eachEl('[data-eqo-cart-btn]', function (btn) {
        btn.disabled = true;
      });
      this.eachEl('[data-eqo-spinner]', function (spinner) {
        spinner.classList.remove('hidden');
      });
      this.eachEl('[data-eqo-cart-btn-label]', function (label) {
        label.style.visibility = 'hidden';
      });
      this.eachEl('[data-eqo-cart-error]', function (errorEl) {
        errorEl.classList.add('hidden');
      });

      var cartDrawer = document.querySelector('cart-drawer');
      var body = {
        items: items,
      };

      if (cartDrawer) {
        body.sections = cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        });
        body.sections_url = window.location.pathname;
      }

      var fetchOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      };

      var url = this.config.cartAddUrl || (window.routes && window.routes.cart_add_url) || '/cart/add';

      fetch(url, fetchOptions)
        .then(function (response) {
          return response.text().then(function (text) {
            var data;
            try {
              data = JSON.parse(text);
            } catch (e) {
              throw new Error('カートへの追加に失敗しました');
            }
            if (data.status || data.description) {
              throw new Error(data.description || 'カートへの追加に失敗しました');
            }
            return data;
          });
        })
        .then(function (data) {
          if (cartDrawer) {
            if (cartDrawer.classList.contains('is-empty')) {
              cartDrawer.classList.remove('is-empty');
            }
            cartDrawer.renderContents(data);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'easy-quote-order', cartData: data });
            }
          } else {
            window.location.href = self.config.cartUrl || '/cart';
          }
        })
        .catch(function (err) {
          var message = err.message || 'カートへの追加に失敗しました';
          self.eachEl('[data-eqo-cart-error]', function (errorEl) {
            errorEl.textContent = message;
            errorEl.classList.remove('hidden');
          });
        })
        .finally(function () {
          self.eachEl('[data-eqo-cart-btn]', function (btn) {
            btn.disabled = false;
          });
          self.eachEl('[data-eqo-spinner]', function (spinner) {
            spinner.classList.add('hidden');
          });
          self.eachEl('[data-eqo-cart-btn-label]', function (label) {
            label.style.visibility = '';
          });
          self.recalculate();
        });
    }
  }

  customElements.define('easy-quote-order', EasyQuoteOrder);
})();
